const state = {
  userId: null,
  authToken: null,
  username: null,
  isAdmin: false
};

module.exports = {
  state
};